import { render, staticRenderFns } from "./DialogConsultarSolicitacao.vue?vue&type=template&id=4ad220fd"
import script from "./DialogConsultarSolicitacao.vue?vue&type=script&lang=js"
export * from "./DialogConsultarSolicitacao.vue?vue&type=script&lang=js"
import style0 from "./DialogConsultarSolicitacao.vue?vue&type=style&index=0&id=4ad220fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports